module.exports = __webpack_public_path__ + "static/img/datamanage.f3fa60c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datamanage.png
// module id = nq7E
// module chunks = 0